import { render, staticRenderFns } from "./PricingTradeInfo.vue?vue&type=template&id=78171c10&"
import script from "./PricingTradeInfo.vue?vue&type=script&lang=js&"
export * from "./PricingTradeInfo.vue?vue&type=script&lang=js&"
import style0 from "./PricingTradeInfo.vue?vue&type=style&index=0&id=78171c10&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports